/**
 * Labstep
 *
 * @module prosemirror/nodes/experiment-workflow-link
 * @desc ExperimentWorkflowLink node
 */

import type { LabstepNode } from 'labstep-web/prosemirror/nodes/types';
import { getAttrsForId } from 'labstep-web/prosemirror/nodes/utils';
import type { Node as ProseMirrorNode } from 'prosemirror-model';

const key = 'experiment_workflow_link';

export const NodeExperimentWorkflowLink: LabstepNode = {
  key,
  spec: {
    attrs: {
      guid: { default: null },
    },
    inline: true,
    group: 'inline',
    marks: '',
    // atom: true,
    draggable: true,
    parseDOM: [{ tag: 'span', getAttrs: getAttrsForId(key) }],
    toDOM(node: ProseMirrorNode) {
      const { guid } = node.attrs;
      return ['span', { [`data-${key}-guid`]: guid }];
    },
  },
};
